import SecureLS from 'secure-ls'

export const ls = new SecureLS({ encodingType: 'aes' })
export const token = ls.get('token')
